var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"help"}},[_c('h1',{staticClass:"title is-2"},[_vm._v(_vm._s(_vm.$t('nav.faq')))]),_c('div',{staticClass:"container"},[_c('VueFaqAccordion',{attrs:{"items":_vm.$t('faq')}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }